import _ from 'lodash';
const state = {
  // imageData: {},
  modalImage: '',
  modalImageBackgroundAudio: {},
  modalImageActive: false,
};

const mutations = {
  CHANGE_MODALIMAGE_CONTENT(state, value) {
    state.modalImage = value;
  },
  ACTIVATE_MODALIMAGE(state) {
    state.modalImageActive = true;
  },
  DEACTIVATE_MODALIMAGE(state) {
    state.modalImageActive = false;
  },
  SET_MODALIMAGE_BACKGROUND_AUDI(state, audioElement) {
    state.modalImageBackgroundAudio = audioElement;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  modalImage: (state) => {
    return state.modalImage;
  },
  isModalImageActive: (state) => {
    return state.modalImageActive;
  },
  modalImageBackgroundAudio: (state) => {
    return state.modalImageBackgroundAudio;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
